import CommonButton from "@/components/utils/CommonButton";
import { UndoIcon } from "@/components/utils/icons/UndoIcon";
import LazoModal from "@/components/utils/LazoModal";
import { Colors } from "@/enums/Colors";
import { DataRoomLazoModalSx } from "@/pages/OneDataRoomPage";
import { customMuiTheme } from "@/utils/AppThemeStyle";
import { Box, styled, Typography } from "@mui/material";

interface Props {
  open: boolean;
  title: string;
  description: string;
  handleOnClickClose: () => void;
  handleOnClickUndo: () => void;
}

export const DataRoomNotificationModal = ({ open, title, description, handleOnClickClose, handleOnClickUndo }: Props) => {
  return (
    <LazoModal
      open={open}
      sx={{
        ...DataRoomLazoModalSx,
        position: "absolute",
        right: "2%",
        bottom: "5%",
      }}
      title={title}
      titleSxProps={{ fontWeight: customMuiTheme.typography.fontWeightBold }}
      handleClose={handleOnClickClose}
    >
      <Container className="main-container">
        <Text className="description">{description}</Text>
        <Container className="button-container">
          <CommonButton
            sx={{
              fontWeight: customMuiTheme.typography.fontWeightBold,
              width: "75%",
            }}
            // purpleBorderVariant
            onClick={handleOnClickClose}
          >
            Close
          </CommonButton>
          <CommonButton
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: ".5rem",
              fontWeight: customMuiTheme.typography.fontWeightBold,
              width: "75%",
            }}
            purpleBorderVariant
            onClick={handleOnClickUndo}
          >
            <UndoIcon sx={{ fill: Colors.LAZO_PURPLE }} />
            Undo
          </CommonButton>
        </Container>
      </Container>
    </LazoModal>
  );
};

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  "&.main-container": {
    flexDirection: "column",
    gap: "1rem",
  },
  "&.button-container": {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "1rem",
  },
}));

const Text = styled(Typography)(({ theme }) => ({
  "&.description": {
    color: Colors.LIGHT_GRAY_8A8E93,
    fontSize: "12px",
  },
}));
